/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Broker to add
 */
export interface CreateGame { 
    /**
     * Game name
     */
    name: string;
    /**
     * Game description
     */
    description?: string;
    /**
     * Rules id
     */
    rulesId: number;
    /**
     * Players count
     */
    playersCount: number;
}